import { Editor, Node, Path } from 'slate';
import { AulaEntities, isAulaEntity } from '../../Entities';
import { insertFilesFromEvent } from '../../lib/insertFilesFromEvent';
import { AulaPlugin } from '../plugins';

export const handlePaste: AulaPlugin = (editableProps, editor, context) => {
  if (context == null) {
    throw new Error('context must be defined');
  }
  return {
    ...editableProps,
    onPaste: (event: React.ClipboardEvent) => {
      const pastedData = event.clipboardData.getData('application/json');

      if (pastedData) {
        const entitiesData: AulaEntities = JSON.parse(pastedData);
        Object.entries(entitiesData).forEach(([entityId, entity]) => {
          if (isAulaEntity(entity)) {
            context.updateEntity(entityId, entity);
          }
        });
      } else if (event.clipboardData.types.includes('text/plain')) {
        const textContent = event.clipboardData.getData('text/plain');

        // The match naively tries to find paragraphs split by a hard break, while
        // ignoring soft breaks within a paragraph. Areas with multiple new lines
        // will also be greedily consumed down to a single break, preventing weird
        // spacing issues for the end user, at the cost of breaking any weird content
        // relying on multiple empty lines.
        textContent.split(/\n\n+/g).forEach((textLine, index) => {
          // Try to figure out if the previous node is empty, and add the contents of the
          // first paragraph to it, for the first paragraph being pasted.
          //
          // This prevents users from always seeing an empty line when pasting into an
          // empty editor, which by default contains an empty text node at the start.
          if (index === 0 && editor.selection) {
            const selectedNodePath = Path.parent(editor.selection.anchor.path);
            const selectedNode = Node.get(editor, selectedNodePath);

            if (!Editor.isVoid(editor, selectedNode)) {
              return Editor.insertText(editor, textLine);
            }
          }

          // If the text line/paragraph can't be merged with a previous empty node, insert it
          // as an entirely new node:
          return Editor.insertNode(editor, {
            children: [{ text: textLine }],
          });
        });

        event.preventDefault();
        /**
         * When copying from word, word adds files to the clipboard event
         * as well as text, html and rtf 😅
         * therefore we need this condition to be explicit
         */
      } else if (
        !event.clipboardData.types.includes('text/plain') &&
        !event.clipboardData.types.includes('text/html') &&
        event.clipboardData.files.length > 0
      ) {
        insertFilesFromEvent(editor, event, context, editor.selection);
      }
    },
  };
};
